/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'match-and-action-wrapper';
const prefix = `${moduleName}.${componentName}`;

export const matchSectionHeader = `${prefix}.matchSectionHeader`;
export const actionSectionHeader = `${prefix}.actionSectionHeader`;

export const ENGLISH = {
    [matchSectionHeader]: 'Match',
    [actionSectionHeader]: 'Action',
};
